Ext.define('SA.model.Notices', {
    singleton: true,

    acknowledge({id, ids}) {
        var data = ids || [id];

        SA.Ajax.request({method: 'acknowledge', resource: 'notifications/user', data});
    },

    deserialize(notices) {
        return {
            adHoc: this.deserializeAdHocNotices(notices),
            tutorial: get('onboarding-tutorial', ({user_notification_id: id}) => new SA.model.TutorialNotice(id)),

            packageDataRemoved: getAll('package-data-removed', notices => {
                return SA.model.PackageDataRemovedNotice.deserialize(notices);
            }),

            pointPackageDowngraded: getAll('point-package-downgraded', notices => {
                return SA.model.PointPackageDowngradedNotice.deserialize(notices);
            })
        };

        function get(type, callback) {
            var notice = notices.find(notice => notice.type === type);

            if (notice) {
                return callback(notice);
            }
        }

        function getAll(types, callback) {
            var types = Array.isArray(types) ? types : [types],
                filteredNotices = notices.filter(({type}) => types.includes(type));

            if (filteredNotices.length) {
                return callback(filteredNotices);
            }
        }
    },

    deserializeAdHocNotices(allNotices) {
        return allNotices
            .filter(({type}) => ['notice-titled', 'autoshow-notice-titled'].includes(type))
            .map(notice => {
                var type = notice.type,
                    id = notice.user_notification_id,
                    date = new Date(notice.created * 1000),
                    listed = notice.listed,
                    read = notice.acknowledged ?? false,
                    titleText = notice.title,
                    messageHtml = notice.message;

                return new SA.model.Notification({type, id, date, listed, read, titleText, messageHtml});
            });
    },

    markListed({ids}) {
        SA.Ajax.request({method: 'markListed', resource: 'notifications/user', data: ids});
    }
});